module.exports = "<div data-ui-view='hero' class=\"hero-banner\"></div>\r\n<div data-ui-view=\"content\" class=\"content-banner\"></div>";